import React from "react";
import { Link } from "gatsby";
import { H4 } from "storybook-components/Typography";
import styled from "styled-components";

const StyledHomeLink = styled(Link)`
  display: block;
  background-color: transparent;
  text-decoration: none;
`;

const StyledHomeText = styled(H4)`
  margin: 0 0 16px;
  color: ${({ theme }) => theme.colors.green5};
  &:hover {
    color: ${({ theme }) => theme.colors.gray12};}
  }
`;

const NavHomeLink = ({ children, className, to }) => {
  return (
    <StyledHomeLink className={className} to={to}>
      <StyledHomeText>{children}</StyledHomeText>
    </StyledHomeLink>
  );
};

export default NavHomeLink;
